import { z } from 'zod';

export const PAYMENT_SITUATIONS = {
  a: 'Since 6 April, this is my only job',
  b: 'This is my only job; however I have had other jobs since 6 April',
  c: 'I have another job or receive a state or occupational pension',
} as const;

export type PaymentSituationCode = keyof typeof PAYMENT_SITUATIONS;

export const paymentSchema = z.object({
  situation: z.enum(['a', 'b', 'c'], {
    required_error: 'Select your employment situation',
  }),
});

export type Payment = z.infer<typeof paymentSchema>;
